module.exports = __webpack_public_path__ + "img/code1.118a614e.jpg";